const resistorNoiseBase = 4.07e-9;

export function getNoiseOpAmpTopPick(opAmpsList, noiseResistance) {
  var result = null;
  var opAmps = [];
  if (opAmpsList.length === 1) {
    opAmps.push(opAmpsList[0]);
  } else {
    opAmps = _getLowNoiseOpAmps(opAmpsList, noiseResistance);
  }

  if (opAmps.length > 1) {
    result = _getLowestPowerOpAmpFromList(opAmps);
  } else {
    result = opAmps[0];
  }

  return result;
}

export function getPowerOpAmpTopPick(opAmpsList) {
  var result = null;
  if (opAmpsList.length === 1) {
    result = opAmpsList[0];
  } else {
    result = _getLowestPowerOpAmpFromList(opAmpsList);
  }

  return result;
}

export function getVoltageRangeOpAmpTopPick(opAmpsList, totalGain, vsMinus, vsPlus) {
  var result = null;
  if (opAmpsList.length === 1) {
    result = opAmpsList[0];
  } else {
    result = _getBiggestRoomFromList(opAmpsList, vsPlus, vsMinus, totalGain);
  }

  return result;
}

// Noise
function _getLowNoiseOpAmps(opAmpsList, noiseResistance) {
  var rNoise = Math.sqrt(noiseResistance / 1000) * resistorNoiseBase;
  var lowNoiseOpAmps = opAmpsList.filter((item) => {
    let vNoise = item.vNoise;
    let iNoiseV = noiseResistance * item.iNoise;
    let opAmpNoise = Math.sqrt(vNoise * vNoise + iNoiseV * iNoiseV);
    return 2.5 * opAmpNoise < rNoise;
  });

  if (lowNoiseOpAmps.length === 0) {
    let opAmpNoiseArray = opAmpsList.map((item) => {
      let vNoise = item.vNoise;
      let iNoiseV = noiseResistance * item.iNoise;
      let opAmpNoise = Math.sqrt(vNoise * vNoise + iNoiseV * iNoiseV);
      return opAmpNoise;
    });

    let lowestNoise = Math.min.apply(Math, opAmpNoiseArray);
    for (let i = opAmpNoiseArray.length - 1; i >= 0; i--) {
      if (opAmpNoiseArray[i] === lowestNoise) {
        lowNoiseOpAmps.push(opAmpsList[i]);
        break;
      }
    }
  }

  return lowNoiseOpAmps;
}

// Power
function _getLowestPowerOpAmpFromList(opAmpsList) {
  var lowestSupplyCurrent = opAmpsList.length > 1 ? opAmpsList[0].supplyCurrent : null;
  var currentAmp = null;
  var result = null;

  for (var i = 0; i < opAmpsList.length; i++) {
    currentAmp = opAmpsList[i];

    if (currentAmp.supplyCurrent < lowestSupplyCurrent || currentAmp.supplyCurrent === lowestSupplyCurrent) {
      lowestSupplyCurrent = currentAmp.supplyCurrent;
      result = currentAmp;
    }
  }

  return result;
}

// Voltage Range
function _getBiggestRoomFromList(opAmpsList, vsPlus, vsMinus, totalGain) {
  if (opAmpsList.length === 0) {
    return null;
  }

  var firstOpAmpInputRoom = _getInputRoom(vsPlus, vsMinus, opAmpsList[0]);
  var firstOpAmpOutputRoom = _getOutputRoom(vsPlus, vsMinus, opAmpsList[0]);
  var biggestRoom = Math.min(firstOpAmpInputRoom, firstOpAmpOutputRoom / totalGain);
  var currentAmp = null;
  var result = null;
  for (var i = 0; i < opAmpsList.length; i++) {
    currentAmp = opAmpsList[i];

    var inputRoom = _getInputRoom(vsPlus, vsMinus, opAmpsList[i]);
    var outputRoom = _getOutputRoom(vsPlus, vsMinus, opAmpsList[i]);
    var room = Math.min(inputRoom, outputRoom / totalGain);

    if (room >= biggestRoom) {
      biggestRoom = room;
      result = currentAmp;
    }
  }

  return result;
}

function _getInputRoom(vsPlus, vsMinus, opAmp) {
  var refV = 0;
  if (vsMinus === 0) {
    refV = vsPlus / 2;
  }

  var posInRoom = vsPlus - opAmp.inHeadroomPlus - refV;
  var negInRoom = refV - vsMinus + opAmp.inHeadroomMinus;
  return Math.min(posInRoom, negInRoom);
}

function _getOutputRoom(vsPlus, vsMinus, opAmp) {
  var refV = 0;
  if (vsMinus === 0) {
    refV = vsPlus / 2;
  }

  var posOutRoom = vsPlus - opAmp.outHeadroomPlus - refV;
  var negOutRoom = refV - vsMinus + opAmp.outHeadroomMinus;
  return Math.min(posOutRoom, negOutRoom);
}
